import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78046056"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "outer" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "確認", -1))
const _hoisted_5 = { class: "list" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Paginaiton = _resolveComponent("Paginaiton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("nav", null, [
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: _normalizeClass({'current': _ctx.isSendHistory}),
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showSendHistory && _ctx.showSendHistory(...args)))
              }, "申請履歴", 2)
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                class: _normalizeClass({'current': _ctx.isApproveHistory}),
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showApproveHistory && _ctx.showApproveHistory(...args)))
              }, "承認履歴", 2)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Paginaiton, {
            items: _ctx.RequestList,
            itemNumPerPage: 12
          }, null, 8, ["items"])
        ])
      ])
    ])
  ]))
}